import { useState } from 'react';
import { captureElementAsPng } from '../utils/captureElement.js';
import { DororaidIcon } from './DororaidIcon.jsx';

function captureErrorNotice(error) {
  const code = String(error?.code || error?.message || '');
  if (code.includes('capture_timeout')) return '이미지 생성 시간 초과';
  if (code.includes('capture_asset_failed')) return '외부 이미지 처리 실패';
  if (code.includes('capture_size_failed')) return '화면 크기 초과';
  if (code.includes('capture_target_missing')) return '저장할 화면 없음';
  return '저장 실패';
}

export function PageCaptureButton({ selector, filename, label = '이미지 저장', compact = false, placement = 'flow' }) {
  const [working, setWorking] = useState(false);
  const [notice, setNotice] = useState('');
  const inFlow = placement === 'flow';
  const controlSize = compact ? 36 : 42;

  const capture = async () => {
    if (working) return;
    const target = document.querySelector(selector);
    if (!target) {
      setNotice('저장할 화면 없음');
      window.setTimeout(() => setNotice(''), 2600);
      return;
    }

    setWorking(true);
    setNotice('');
    try {
      await captureElementAsPng(
        target,
        typeof filename === 'function' ? filename() : filename,
      );
      setNotice('저장됨');
    } catch (error) {
      console.error('Page capture failed', {
        code: error?.code || error?.message,
        detail: error?.detail,
        error,
      });
      setNotice(captureErrorNotice(error));
    } finally {
      setWorking(false);
      window.setTimeout(() => setNotice(''), 3600);
    }
  };

  const flowActionStyle = inFlow ? {
    position: 'static',
    inset: 'auto',
    zIndex: 'auto',
    display: 'inline-flex',
    width: 'auto',
    minWidth: 0,
    height: 'auto',
    minHeight: 0,
    flex: '0 0 auto',
    alignItems: 'center',
    gap: 6,
    margin: 0,
    transform: 'none',
  } : undefined;
  const flowButtonStyle = inFlow ? {
    position: 'static',
    inset: 'auto',
    width: controlSize,
    minWidth: controlSize,
    height: controlSize,
    minHeight: controlSize,
    margin: 0,
    padding: 0,
    transform: 'none',
  } : undefined;
  const flowNoticeStyle = inFlow ? {
    position: 'static',
    inset: 'auto',
    margin: 0,
    transform: 'none',
  } : undefined;

  return (
    <div className={`page-capture-action${compact ? ' compact' : ''}${inFlow ? ' flow' : ''}`} style={flowActionStyle} data-capture-placement={placement} data-capture-exclude="true">
      <button type="button" className="page-capture-button" style={flowButtonStyle} onClick={capture} disabled={working} title={working ? '이미지 저장 중…' : label} aria-label={working ? '이미지 저장 중' : label}>
        <DororaidIcon name="capture" size={20} />
      </button>
      {notice ? <small role="status" style={flowNoticeStyle}>{notice}</small> : null}
    </div>
  );
}
